import './Appadmin.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './login';
import AdminPanel from './AdminPanel';
import Dashboard from './Dashboard';
import Messages from './Messages';
import UserManagement from './UserManagement';
import AboutUs from './AboutUs';
import PrivacyPolicy from './PrivacyPolicy';
import Termspanel from './Termspanel';
import Homepanel from './Homepanel';
import Categorypanel from './categorypanel';
import ApplicationAdmin from './ApplicationAdmin';
import SystemSettings from './Systemsettings';
import Reports from './Reports';

function AppAdmin() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/msg" element={<Messages />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/dash" element={<Dashboard />} />
        <Route path="/usermanagement" element={<UserManagement />} />
        <Route path="/reports" element={<Reports />} />
        
        <Route path="/Aboutus" element={<AboutUs />} />
        <Route path='/policy' element={<PrivacyPolicy/>}/>
        <Route path='/Termspanel' element={<Termspanel/>}/>
        <Route path='/Homepanel' element={<Homepanel/>}/>
        <Route path='/categorypanel' element={<Categorypanel/>}/>
        <Route path='/applicationstatus' element={<ApplicationAdmin/>}/>
        <Route path='/SystemSettings' element={<SystemSettings/>}/>
      </Routes>
    </Router>
  );
}

export default AppAdmin;

